import store from "@/store";
import { decrypt, encrypt } from "../services/EncryptionService";
// import OrchApiService from "../services/apiServices/OrchApiService";
let orchApiService: any | null = null

const getWord = (key: string) => {
    try {
        if (key) {
            if (key.indexOf('/') > -1) {
                const values: string[] = []
                const keys = key.split('/')
                keys.forEach((_key) => {
                    values.push(Translator.getWord(_key))
                })
                return values.join('/')
            }
            else {
                return Translator.getWord(key);
            }
        }

        return key;
    }
    catch {
        return key;
    }
};

const loadTranslations = async (): Promise<void> => {
  await Translator.getTranslations();
};

class Translator {
    private static TRANSLATIONS_KEY = "Translations";

    public static getWord(key: string) {
        const translations = this.getTranslationsFromLocalStorage();
        const translation = translations.find(p => p.key === store.getters.language);
        if (translation && translation.translations) {
            const pair = (translation.translations as Array<any>).find((elem) => {
                return elem.key === key
            })
            if (pair && pair.value) {
                return pair.value;
            }
        }
        // Translator.addWord(key)

        return key;
    }

    public static async addWord(key: string) {
        orchApiService = (await require("../services/apiServices/OrchApiService")).default

        orchApiService.Settings.Translation.getWord(key)
    }

    public static async getTranslations() {
        await this.getAllTranslationsFromServer();
        return this.getTranslationsFromLocalStorage();
    }
    
    private static async getAllTranslationsFromServer(): Promise<void> {
        if (!orchApiService) {
            orchApiService = (await import("../services/apiServices/OrchApiService")).default;
        }
        
        const response = await orchApiService.Settings.Translation.getAllTranslations();

        const { hasFailed, data } = response.data;

        if (!hasFailed && Array.isArray(data)) {
            this.saveTranslationsToLocalStorage(data);
        }
    }
    private static saveTranslationsToLocalStorage(values: any[]): void {
        const jsonValues = JSON.stringify(values)
        const encryptedValues = encrypt(jsonValues)
        window.localStorage.setItem(this.TRANSLATIONS_KEY, encryptedValues)
    }
    private static getTranslationsFromLocalStorage(): Array<any> {
        const encryptedTranslations = window.localStorage.getItem(this.TRANSLATIONS_KEY);
        if (encryptedTranslations) {
            const translationsJson = decrypt(encryptedTranslations)
            return JSON.parse(translationsJson);
        }
        return [];
    }
}

export { getWord, loadTranslations };
